export enum SurveySortAlgorithm {
    highestScore = 'HIGHEST_SCORE',
    balancedSelection = 'BALANCED_SELECTION',
    categoryPriority = 'CATEGORY_PRIORITY',
}

export const SURVEY_STORAGE_KEY = 'personalization-survey';
export const SURVEY_RESULTS_CACHE_KEY = 'product-list-survey-results-cache';
export const SURVEY_RESTART_REQUESTED_KEY = 'personalization-survey-restart-requested';
export const SURVEY_RESULTS_CACHE_TTL_MS = 30 * 60 * 1000; // 30 min

export enum SurveyResultPresentationVariant {
    showPoints = 'SHOW_POINTS',
    showProducts = 'SHOW_PRODUCTS',
    showPrice = 'SHOW_PRICE',
    addToCart = 'ADD_TO_CART',
    forYouSection = 'FOR_YOU_SECTION',
    shareResults = 'SHARE_RESULTS',
}

export type SurveyShort = {
    entity_id: number;
    uid: string;
    comment: string;
    is_editable: number;
    is_published: number;
};

export type SurveyDetails = {
    entity_id: number;
    uid: string;
    comment: string;
    is_editable: number;
    is_published: number;
    survey_structure: string;
    creator_state: string;
    survey_summary: string;
};

//todo extend SurveyDetails with parsed survey_structure and creator_state
export type SurveyQuestion = {
    name: string;
    uid: string; //kebak-case of name
    isMultiple: boolean;
    maxAnswers?: number;
    answers: SurveyQuestionAnswer[];
    isMain?: boolean;
};
export type SurveyQuestionAnswer = {
    name: string;
    uid: string; //kebak-case of name
    singleInMultiple?: boolean; //for multiple questions - if true, selecting this answer will deselect other answers
    includedSkus: string[];
    excludedSkus: string[]
    nextQuestionUid?: string;
    description?: string | null;
    productsDescription?: Record<string, string>; // key - sku, value - description for this answer (if product is included in answer)
};

export type SurveyResultDefinition = {
    minQuantity: number;
    maxQuantity: number;
    sortAlgorithm: SurveySortAlgorithm;
    variants?: SurveyResultPresentationVariant[];
};

export type SurveyRoad = {
    name: string;
    index: number;
    isMultiple: boolean;
    mappedQuestions: SurveyQuestion[];
    availableExternalRoadsQuestionsUids: string[][];
    productGroupUids: string[];
};

export type SurveyStructure = {
    productsGroups: {
        name: string;
        uid: string; //kebak-case of name
        skus: string[];
        isMain?: boolean;
    }[];
    questions: SurveyQuestion[];
    chart?: string;
    roads: SurveyRoad[];
    resultsDefinition: SurveyResultDefinition;
};

export type Survey = Omit<
    SurveyDetails,
    'survey_structure' | 'creator_state' | 'survey_summary'
> & {
    survey_structure: SurveyStructure;
    creator_state: Record<string, any>;
    // survey_summary:  Record<string, any>;
};

export type SurveyLocalSelectedRoadData = {
    questionUid: string;
    answerUids: string[];
    eternalRoadAnswersUid?: string[];

}
//todo dokończ mnie
export type SurveyLocalStatus = 'main-page' | 'questions' | 'results' | 'save';
export type SurveyLocalData = SurveyResults & {
    currentQuestionUid?: string;
    shortSurveyStatus?: 'started' | 'finished' | 'advanced';
};

export type SurveyResults = {
    time?: number;
    status?: SurveyLocalStatus;
    hashId?: string | null;
    version?: number;
    answers?: {
        answers_data: Array<unknown>;
        selectedExternalRoadData: Array<SurveyLocalSelectedRoadData>;
        selectedRoadData: Array<SurveyLocalSelectedRoadData>;
        hasAdvancedRoad: boolean;
        version: number | null;
    }
    results: {
        sku: string,
        description?: string | null;
    }[];
}

export type SurveySaveMode = 'save' | 'discount';
export type SurveyDiscountCodeStatus = 'active' | 'expired' | 'used';

export type SurveyDiscountCodeStorage = {
    status?: string | null;
    code?: string | null;
    expires_at?: string | null;
};

export type SurveyResultsWithDiscountCode = SurveyResults & {
    discountCode?: SurveyDiscountCodeStorage | null;
    saveMode?: SurveySaveMode;
    guestEmail?: string;
};
